"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DG_EVENT_TYPE_1 = require("../core/DG_EVENT_TYPE");
const utils_1 = require("../internal/utils");
exports.LG_EVENT_TYPE = utils_1.extend(DG_EVENT_TYPE_1.DG_EVENT_TYPE, {
    CHANGED_VALUE: "changed_value",
    CHANGED_HEADER_VALUE: "changed_header_value",
});
